module.exports = __webpack_public_path__ + "img/gal-6.5f1354a8.jpg";